export function getComponentName(def) {
    return 'displayName' in def && typeof def.displayName === 'string' ? def.displayName : def.name;
}
//# sourceMappingURL=getComponentName.js.map